<div class="mct-flex mct-col mct-gap-27" *ngIf="pledgeCampaign" ngModelGroup="pledgeCampaign">
  <div class="mct-grid mct-cols-1-1 mct-grid-lt-md mct-cols-1-lt-md mct-gap-27 pledge-campaign-grid">
    <div class="area-header">
      <span class="section-header area-header">{{
        'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.title' | translate | titlecase
      }}</span>
    </div>

    <div class="area-progress-bar">
      <wl-pledge-campaign-details-edit-progressbar
        [pledgeCampaign]="pledgeCampaign"
        class="w-100"
      ></wl-pledge-campaign-details-edit-progressbar>
    </div>

    <div class="area-name">
      <label>{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-name' | translate | ucfirst }}</label>
      <input pInputText required name="pledgeCampaignName" [(ngModel)]="pledgeCampaign.CampaignName" />
    </div>

    <div class="area-left-fields">
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-type' | translate | titlecase }}</label>
        <p-select
          required
          appendTo="body"
          name="campaignTypeId"
          [(ngModel)]="pledgeCampaign.PledgeCampaignTypeId"
          [options]="pledgeCampaignTypes"
          showClear
          [placeholder]="'revenue.pledge-campaigns.pledge-campaign.campaign-type-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.start-date' | translate | titlecase }}</label>
        <wl-date-selector appendTo="body" [required]="true" name="startDate" [(ngModel)]="pledgeCampaign.StartDate"></wl-date-selector>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.end-date' | translate | titlecase }}</label>
        <wl-date-selector appendTo="body" [required]="true" name="endDate" [(ngModel)]="pledgeCampaign.EndDate"></wl-date-selector>
      </div>
    </div>

    <div class="area-right-fields">
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.goal' | translate | titlecase }}</label>
        <div class="p-inputgroup">
          <span class="atlas-input-addon">$</span>
          <p-inputNumber
            name="goal"
            [(ngModel)]="pledgeCampaign.Goal"
            showClear="true"
            mode="decimal"
            [style]="{ width: '100%' }"
            [min]="0"
          ></p-inputNumber>
        </div>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-year' | translate | titlecase }}</label>
        <p-datepicker
          appendTo="body"
          name="campaignYear"
          showClear="true"
          [(ngModel)]="pledgeCampaignYear"
          view="year"
          dateFormat="yy"
          [style]="{ width: '100%' }"
          showIcon="true"
          (onSelect)="updateCampaignYear()"
          (onInput)="updateCampaignYear()"
        ></p-datepicker>
      </div>
      <div class="mb-20">
        <label class="light-text">{{ 'revenue.pledge-campaigns.pledge-campaign.campaign-descr' | translate | titlecase }}</label>
        <textarea pInputTextarea [(ngModel)]="pledgeCampaign.Descr" name="campaignDescr"></textarea>
      </div>
    </div>
  </div>
</div>
